<template>
  <div class="card mb-4">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-md-6 text-muted">{{ $t('word.name') }}:</div>
        <div class="col-md-6">
          {{ organisation.name }}
        </div>
      </div>

      <div
        class="row mb-2"
        v-if="organisation.address"
      >
        <div class="col-md-6 text-muted">{{ $t('word.address') }}:</div>
        <div class="col-md-6">
          {{ organisation.address }}
        </div>
      </div>

      <div
        class="row mb-2"
        v-if="organisation.zip"
      >
        <div class="col-md-6 text-muted">{{ $t('word.zip') }}:</div>
        <div class="col-md-6">
          {{ organisation.zip }}
        </div>
      </div>

      <div
        class="row mb-2"
        v-if="organisation.city"
      >
        <div class="col-md-6 text-muted">{{ $t('word.city') }}:</div>
        <div class="col-md-6">
          {{ organisation.city }}
        </div>
      </div>
      <div
        class="row mb-2"
        v-if="organisation.country"
      >
        <div class="col-md-6 text-muted">{{ $t('word.country') }}:</div>
        <div class="col-md-6">
          {{ organisation.country }}
        </div>
      </div>
    </div>
    <div class="card-footer text-center p-0">
      <div class="row no-gutters row-bordered row-border-light">
        <div
          class="d-flex col flex-column text-dark py-3"
          v-if="commercialsCount"
        >
          <div class="font-weight-bold">{{ commercialsCount }}</div>
          <div class="text-muted small">
            {{ $tc('word.commercial', commercialsCount).toLowerCase() }}
          </div>
        </div>
        <div
          class="d-flex col flex-column text-dark py-3"
          v-if="reviewsCount"
        >
          <div class="font-weight-bold">
            {{ reviewsCount }}
          </div>
          <div class="text-muted small">
            reviews
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganisationInfoBlock',
  props: {
    organisation: {
      required: true,
      type: Object,
    },
    commercialsCount: {
      type: Number,
      required: false,
    },
    reviewsCount: {
      type: Number,
      required: false,
    },
  },
};
</script>
